import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["password", "passwordConfirmation"]

  initialize() {
    // validations
    this.choosePasswordForm = this.choosePasswordForm();
  }

  choosePasswordForm(){
    let self = this;
    return FormValidation.formValidation(
      document.getElementById('choosePasswordForm'),
      {
        fields: {
          password: {
            selector: '[name="user[password]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Password is required'
              },
              regexp: {
                message: "Password must be a minimum of 8 characters and contain at least 1 upper case letter and 1 digit or special character",
                regexp: /(?=.*[a-z])(?=.*[A-Z])((?=.*\d)|(?=.*\W)).{8,}/,
              },
            }
          },
          passwordConfirmation: {
            selector: '[name="user[password_confirmation]"]',
            validators: {
              callback: {
                callback: function() {
                  return {
                    valid: self.checkPasswordsMatch(),
                    message: "Passwords don't match"
                  }
                }
              }
            }
          },
        },
        plugins: {
          bootstrap5: new Bootstrap5({
            rowSelector: '.validate-field'
          }),
          autoFocus: new AutoFocus(),
          submitButton: new FormValidation.plugins.SubmitButton(),
          aria: new FormValidation.plugins.Aria(),
        },
      }
    )
  }

  submitSetPassword() {
    document.getElementById("setPasswordSubmit").disabled = true;
    this.choosePasswordForm.validate().then(function (status) { 
      if (status == 'Valid') {
        document.getElementById("choosePasswordForm").submit();
      } else {
        document.getElementById("setPasswordSubmit").disabled = false;
      }
    });
  }

  checkPasswordsMatch(){
    return this.passwordTarget.value == this.passwordConfirmationTarget.value;
  }

}